import axios from 'axios';

const token = document.querySelector('[name=csrf-token').content;
axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

const client = axios.create({
    baseURL: '/api/v1/'
});

client.interceptors.response.use(response => {
    return response;
}, error => {
    let { status } = error.response;
    if (status === 401 || status === 422) {
        window.location = '/users/unauthorized'
    } else {
        return Promise.reject(error);
    }
});

export function getQuestions(examId, sectionId, presentationId) {
    return client.get(`/exams/questions/${examId}/${sectionId}/${presentationId}`);
}

export function getInstructions(instructionId) {
    return client.get(`/exams/instruction/${instructionId}`);
}

export function getQuestion(questionId) {
    return client.get(`/exams/question/${questionId}`);
}

export function sendAnswer(presentationId, sectionIdd, questionId, answerId, minutes) {
    return client.post('/exams/answer', {
        answer: {
            presentation_id: presentationId, section_idd: sectionIdd, question_id: questionId,
            answer_id: answerId, minutes: minutes
        }
    });
}

export function updateSituationTimesShown(presentationId, situationId, situationType) {
    return client.put('/exams/update_situations_state', {
        situations_state: { presentation_id: presentationId, situation_id: situationId, situation_type: situationType }
    });
}

export function getResult(presentationId, examId) {
    return client.get(`/exams/result/${presentationId}/${examId}`);
}

export function sendText(presentationId, text, key) {
    return client.post('/exams/save_text', {
        writing: { IdPresentacionExamen: presentationId, Texto: text, Clave: key }
    });
}
